/** Route to review a completed diag & inspection, and optionally upload photos and videos */
import { createFileRoute, useParams } from '@tanstack/react-router'

import { MobileUploadInspectionPage } from '../../../../../../components/request-drawer/action/inspection_step/mobile-upload/MobileUploadInspectionPage'

export const Route = createFileRoute('/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { providerBranchId, requestId } = useParams({
    from: '/mobile-multi-inspection/provider-branch/$providerBranchId/request/$requestId/',
  })

  return <MobileUploadInspectionPage providerBranchId={providerBranchId} requestId={requestId} />
}
